import { Reducer } from 'redux';

import { Actions } from 'store/actions/govtDocument.action';
import {
    GOVT_FORM_SUBMITTING,
  GOVT_FORM_SUBMITTED,
  GOVT_FORM_FAILED,
  GOVT_FORM_RESET,
  GOVT_UPLOAD_FORM,
} from 'store/types/govtDocument.type';
import { RootReducerType } from './index';

export type State = {
  isSubmitting: boolean;
  error: string;
  success: string | null;
};
const initialState = {
  isSubmitting: false,
  error: '',
  success: '',
};

export const govtDocumentReducer: Reducer<State, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case GOVT_FORM_SUBMITTING:
      return { ...state, isSubmitting: true, error: '', success: '' };
    case GOVT_FORM_SUBMITTED:
      return { ...state, isSubmitting: false, success: action.success };
    case GOVT_FORM_FAILED:
      return { ...state, isSubmitting: false, error: action.error };
    case GOVT_FORM_RESET:
      return initialState;
    case GOVT_UPLOAD_FORM:
      return { ...state, isSubmitting: false, error: '', success: 'abc' };

    default:
      return state;
  }
};

export const govtDocumentSelector = (state: RootReducerType) => state.govtDocument;
export default govtDocumentReducer;

